import script from "./formDgKehadiran.vue?vue&type=script&setup=true&lang=js"
export * from "./formDgKehadiran.vue?vue&type=script&setup=true&lang=js"

import "./formDgKehadiran.vue?vue&type=style&index=0&id=b5d575da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5d575da"]])

export default __exports__